import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import DiscountBanner from '../components/DiscountBanner';
import ReviewBanner from '../components/ReviewBanner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    (async () => {
      try {
        const res = await axios.get(`${API}/blog/posts/${slug}`);
        if (!cancelled) setPost(res.data);
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.status === 404
            ? "We couldn't find that post."
            : "Something went wrong loading this post.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch {
      return iso;
    }
  };

  return (
    <div className="blog-post-page" data-testid="blog-post-page">
      <DiscountBanner size="large" />
      <ReviewBanner />

      <section className="blog-post-section">
        <div className="container blog-post-container">
          <Link to="/blog" className="blog-back-link" data-testid="blog-back-link">← Back to all posts</Link>

          {loading && <p className="blog-status" data-testid="blog-post-loading">Loading…</p>}
          {error && <p className="blog-status blog-error" data-testid="blog-post-error">{error}</p>}

          {post && !loading && !error && (
            <article className="blog-post-article" data-testid={`blog-post-${post.slug}`}>
              <span className="blog-post-category">{post.category}</span>
              <h1 className="blog-post-title">{post.title}</h1>
              <div className="blog-post-meta">
                <span>{post.author}</span>
                <span aria-hidden="true">•</span>
                <span>{formatDate(post.publishedAt)}</span>
                <span aria-hidden="true">•</span>
                <span>{post.readTime}</span>
              </div>

              <img
                src={post.coverImage}
                alt={post.title}
                className="blog-post-cover"
              />

              <div className="blog-post-content">
                {post.content?.map((block, idx) => (
                  <div key={idx} className="blog-post-block">
                    {block.heading && <h2 className="blog-post-heading">{block.heading}</h2>}
                    {block.paragraphs?.map((para, i) => (
                      <p key={i} className="blog-post-paragraph">{para}</p>
                    ))}
                  </div>
                ))}
              </div>

              <div className="blog-post-cta">
                <h3>Need a trusted cat sitter in Walsall?</h3>
                <p>Book a free, no-pressure Meet & Greet — we'd love to look after your cats.</p>
                <Link to="/contact" className="blog-cta-button" data-testid="blog-post-cta-button">
                  Book Free Meet & Greet
                </Link>
              </div>
            </article>
          )}
        </div>
      </section>
    </div>
  );
};

export default BlogPostPage;
